import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class TopFooter extends Component {
    render() {
        return (
            <div className="widget-infomation">
                <ul className="infomation-footer">
                    <li><i className="fa fa-envelope" aria-hidden="true"></i><Link to="#" title="">info@statselite.co.tz</Link></li>
                    <li><i className="fa fa-globe" aria-hidden="true"></i><Link to="#" title="">www.statselite.co.tz</Link></li>
                    <li><i className="fa fa-phone" aria-hidden="true"></i><Link to="tel:+255749663117" title="">+255 749 663 117</Link></li>
                    <li><i className="fa fa-map-marker" aria-hidden="true"></i><Link to="#" title="">PO Box 16122 makumbusho Dar es salaam</Link></li>
                </ul>
                {/* <!-- /.infomation-footer --> */}
            </div>
        /* <!-- /.widget-infomation --> */
        );
    }
}

export default TopFooter;
